import styled from 'styled-components';
import {
  Box,
  IconButton,
} from '@mui/material';

import colors from '../../../../../../../../styles/colors';

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${colors.base.alpha};
  padding: 12px 20px;
`;

const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const NoteCredit = styled.div`
  font-size: 14px;
  line-height: 15px;
  color: ${colors.shades.gamma9};
`;

const StrongTypography = styled.strong`
  font-weight: 600;
`;

const StyledTypography = styled.div`
  font-size: 16px;
  line-height: 18px;
  color: ${colors.shades.secondary3};
  flex-shrink: 0;
`;

const Separator = styled.div`
  margin: 0 8px;
`;

const StyledInfoButton = styled(IconButton)`
  padding: 0 5px;
`;

const NoteText = styled.div`
  font-size: 12px;
  color: ${colors.shades.gamma10};
  margin-left: 7px;
`;

const StyledDate = styled.div`
  min-width: 80px;
  height: fit-content;
  text-align: center;
  padding: 7px;
  font-weight: 500;
  font-size: 12px;
  border-radius: 5px;
  background: ${colors.shades.secondary7};
  border: 1px solid ${colors.shades.secondary4};
`;

export {
  Container,
  ColumnContainer,
  RowContainer,
  NoteCredit,
  Separator,
  StyledTypography,
  StrongTypography,
  StyledInfoButton,
  NoteText,
  StyledDate,
};
